import { TabItem, Toggle } from "@atoms"

import { ListItemStack, TabStack } from "@molecules"
import ListItem from "@molecules/ListItem/ListItem"
import ListItemContent from "@molecules/ListItem/ListItemContent/ListItemContent"

import TimelineViewTimeFrameSelector from "@organisms/ViewMenu/TimelineViewMenu/TimelineViewTimeFrameSelector/TimelineViewTimeFrameSelector"

import useJobTimelineViewEventHandlers from "@pages/Jobs/JobList/views/JobTimelineView/hooks/useJobTimelineViewEventHandlers"
import useTimelineViewStates from "@pages/Jobs/JobList/views/JobTimelineView/hooks/useJobTimelineViewStates"

import styles from "./TimelineViewMenuPopover.module.scss"

export default function TimelineViewMenuPopover() {
    const {
        jobCardStyle,
        setJobCardStyleToCompact,
        setJobCardStyleToRegular,
        shouldShowCancelledJobs,
        shouldShowFinalizedJobs,
        timelineViewOrientation,
        shouldShowWeekends,
    } = useTimelineViewStates()

    const {
        onCancelledJobsToggle,
        onFinalizedJobsToggle,
        onSetSchedulerToHorizontal,
        onSetSchedulerToVertical,
        onShowWeekendsToggle,
    } = useJobTimelineViewEventHandlers()

    return (
        <ListItemStack className={styles.content}>
            <ListItem.Root className={styles.item}>
                <ListItem.AvatarAndContent
                    content={
                        <ListItemContent
                            leftLabel={
                                <ListItem.Label
                                    className={styles.itemLabel}
                                    htmlFor="show-finalized-jobs"
                                    label="Show Finalized Jobs"
                                />
                            }
                        />
                    }
                />
                <ListItem.Actions>
                    <Toggle
                        id="show-finalized-jobs"
                        checked={shouldShowFinalizedJobs}
                        onClick={onFinalizedJobsToggle}
                        isControlled={false}
                    />
                </ListItem.Actions>
            </ListItem.Root>
            <ListItem.Root className={styles.item}>
                <ListItem.AvatarAndContent
                    content={
                        <ListItemContent
                            leftLabel={
                                <ListItem.Label
                                    className={styles.itemLabel}
                                    htmlFor="show-cancelled-jobs"
                                    label="Show Cancelled Jobs"
                                />
                            }
                        />
                    }
                />
                <ListItem.Actions>
                    <Toggle
                        id="show-cancelled-jobs"
                        checked={shouldShowCancelledJobs}
                        onClick={onCancelledJobsToggle}
                        isControlled={false}
                    />
                </ListItem.Actions>
            </ListItem.Root>
            <ListItem.Root className={styles.item}>
                <ListItem.AvatarAndContent
                    content={
                        <ListItemContent
                            leftLabel={
                                <ListItem.Label
                                    className={styles.itemLabel}
                                    htmlFor="show-weekends"
                                    label="Show Weekends"
                                />
                            }
                        />
                    }
                />
                <ListItem.Actions>
                    <Toggle
                        id="show-weekends"
                        checked={shouldShowWeekends}
                        onClick={onShowWeekendsToggle}
                        isControlled={false}
                    />
                </ListItem.Actions>
            </ListItem.Root>

            <ListItem.Root className={styles.item}>
                <ListItem.AvatarAndContent
                    content={
                        <ListItemContent
                            leftLabel={<ListItem.Label className={styles.itemLabel} label="Timeline Orientation" />}
                        />
                    }
                />
                <ListItem.Actions>
                    <TabStack variant="contained" size="md">
                        <TabItem
                            isSelected={timelineViewOrientation === "vertical"}
                            onClick={onSetSchedulerToVertical}
                            noDebounce={true}
                        >
                            Vertical
                        </TabItem>
                        <TabItem
                            isSelected={timelineViewOrientation === "horizontal"}
                            onClick={onSetSchedulerToHorizontal}
                            noDebounce={true}
                        >
                            Horizontal
                        </TabItem>
                    </TabStack>
                </ListItem.Actions>
            </ListItem.Root>

            {timelineViewOrientation === "horizontal" && (
                <ListItem.Root className={styles.item}>
                    <ListItem.AvatarAndContent
                        content={
                            <ListItemContent
                                leftLabel={<ListItem.Label className={styles.itemLabel} label="Job Card Style" />}
                            />
                        }
                    />
                    <ListItem.Actions>
                        <TabStack variant="contained" size="md">
                            <TabItem
                                isSelected={jobCardStyle === "compact"}
                                onClick={setJobCardStyleToCompact}
                                noDebounce={true}
                            >
                                Compact
                            </TabItem>
                            <TabItem
                                isSelected={jobCardStyle === "regular"}
                                onClick={setJobCardStyleToRegular}
                                noDebounce={true}
                            >
                                Regular
                            </TabItem>
                        </TabStack>
                    </ListItem.Actions>
                </ListItem.Root>
            )}

            <ListItem.Root className={styles.item}>
                <ListItem.AvatarAndContent
                    content={
                        <ListItemContent
                            leftLabel={<ListItem.Label className={styles.itemLabel} label="Time Frame" />}
                        />
                    }
                />
                <ListItem.Actions>
                    <TimelineViewTimeFrameSelector.Select />
                </ListItem.Actions>
            </ListItem.Root>
        </ListItemStack>
    )
}
